// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "re-formality/src/Formality.bs.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as Formality__ReactUpdate from "re-formality/src/Formality__ReactUpdate.bs.js";
import * as Utils_Api$DvmAdminFrontendFr from "../../../common/utils/Utils_Api.bs.js";
import * as Utils_Form$DvmAdminFrontendFr from "../../../common/utils/Utils_Form.bs.js";
import * as Contract_Manager_Search_Types$DvmAdminFrontendFr from "./Contract_Manager_Search_Types.bs.js";

var validators_endDate = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return Belt_Result.map(Utils_Form$DvmAdminFrontendFr.validateDate(param.endDate, undefined), (function (date) {
                    return Utils_Api$DvmAdminFrontendFr.dateToQueryParam(Contract_Manager_Search_Types$DvmAdminFrontendFr.Fields.endDate, date);
                  }));
    })
};

var validators_startDate = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return Belt_Result.map(Utils_Form$DvmAdminFrontendFr.validateDate(param.startDate, undefined), (function (date) {
                    return Utils_Api$DvmAdminFrontendFr.dateToQueryParam(Contract_Manager_Search_Types$DvmAdminFrontendFr.Fields.startDate, date);
                  }));
    })
};

var validators_budget = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var tmp;
      switch (param.budget) {
        case "AVS" :
            tmp = "BudgetAVS=true";
            break;
        case "LCD" :
            tmp = "BudgetLCD=true";
            break;
        case "LLD" :
            tmp = "BudgetLLD=true";
            break;
        case "PROT" :
            tmp = "BudgetPROT=true";
            break;
        default:
          tmp = undefined;
      }
      return {
              TAG: /* Ok */0,
              _0: tmp
            };
    })
};

var validators_managerName = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return {
              TAG: /* Ok */0,
              _0: Utils_Api$DvmAdminFrontendFr.stringFieldToQueryParam(undefined, {
                    fieldId: Contract_Manager_Search_Types$DvmAdminFrontendFr.Fields.managerName,
                    value: param.managerName
                  })
            };
    })
};

var validators_managerID = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return {
              TAG: /* Ok */0,
              _0: Utils_Api$DvmAdminFrontendFr.stringFieldToQueryParam(true, {
                    fieldId: Contract_Manager_Search_Types$DvmAdminFrontendFr.Fields.managerID,
                    value: param.managerID
                  })
            };
    })
};

var validators = {
  showHistory: undefined,
  endDate: validators_endDate,
  startDate: validators_startDate,
  budget: validators_budget,
  managerName: validators_managerName,
  managerID: validators_managerID
};

function initialFieldsStatuses(_input) {
  return {
          showHistory: /* Pristine */0,
          endDate: /* Pristine */0,
          startDate: /* Pristine */0,
          budget: /* Pristine */0,
          managerName: /* Pristine */0,
          managerID: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.showHistory
  };
  var match = fieldsStatuses.endDate;
  var match_0$1 = match ? match._0 : Curry._1(validators.endDate.validate, input);
  var match$1 = fieldsStatuses.startDate;
  var match_0$2 = match$1 ? match$1._0 : Curry._1(validators.startDate.validate, input);
  var match$2 = fieldsStatuses.budget;
  var match_0$3 = match$2 ? match$2._0 : Curry._1(validators.budget.validate, input);
  var match$3 = fieldsStatuses.managerName;
  var match_0$4 = match$3 ? match$3._0 : Curry._1(validators.managerName.validate, input);
  var match$4 = fieldsStatuses.managerID;
  var match_0$5 = match$4 ? match$4._0 : Curry._1(validators.managerID.validate, input);
  var showHistoryResult = match_0;
  var showHistoryResult$1;
  if (showHistoryResult.TAG === /* Ok */0) {
    var endDateResult = match_0$1;
    if (endDateResult.TAG === /* Ok */0) {
      var startDateResult = match_0$2;
      if (startDateResult.TAG === /* Ok */0) {
        var budgetResult = match_0$3;
        if (budgetResult.TAG === /* Ok */0) {
          var managerNameResult = match_0$4;
          if (managerNameResult.TAG === /* Ok */0) {
            var managerIDResult = match_0$5;
            if (managerIDResult.TAG === /* Ok */0) {
              return {
                      TAG: /* Valid */0,
                      output: {
                        managerID: managerIDResult._0,
                        managerName: managerNameResult._0,
                        budget: budgetResult._0,
                        startDate: startDateResult._0,
                        endDate: endDateResult._0,
                        showHistory: showHistoryResult._0
                      },
                      fieldsStatuses: {
                        showHistory: /* Dirty */{
                          _0: showHistoryResult,
                          _1: /* Hidden */1
                        },
                        endDate: /* Dirty */{
                          _0: endDateResult,
                          _1: /* Shown */0
                        },
                        startDate: /* Dirty */{
                          _0: startDateResult,
                          _1: /* Shown */0
                        },
                        budget: /* Dirty */{
                          _0: budgetResult,
                          _1: /* Shown */0
                        },
                        managerName: /* Dirty */{
                          _0: managerNameResult,
                          _1: /* Shown */0
                        },
                        managerID: /* Dirty */{
                          _0: managerIDResult,
                          _1: /* Shown */0
                        }
                      },
                      collectionsStatuses: undefined
                    };
            }
            showHistoryResult$1 = showHistoryResult;
          } else {
            showHistoryResult$1 = showHistoryResult;
          }
        } else {
          showHistoryResult$1 = showHistoryResult;
        }
      } else {
        showHistoryResult$1 = showHistoryResult;
      }
    } else {
      showHistoryResult$1 = showHistoryResult;
    }
  } else {
    showHistoryResult$1 = showHistoryResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            showHistory: /* Dirty */{
              _0: showHistoryResult$1,
              _1: /* Hidden */1
            },
            endDate: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            startDate: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            budget: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            managerName: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            managerID: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurShowHistoryField */0 :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.showHistory, state.fieldsStatuses.showHistory, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  showHistory: status,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  budget: init.budget,
                                  managerName: init.managerName,
                                  managerID: init.managerID
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEndDateField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.endDate, validators_endDate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  showHistory: init.showHistory,
                                  endDate: status,
                                  startDate: init.startDate,
                                  budget: init.budget,
                                  managerName: init.managerName,
                                  managerID: init.managerID
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartDateField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.startDate, validators_startDate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  showHistory: init.showHistory,
                                  endDate: init.endDate,
                                  startDate: status,
                                  budget: init.budget,
                                  managerName: init.managerName,
                                  managerID: init.managerID
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurBudgetField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.budget, validators_budget, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  showHistory: init.showHistory,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  budget: status,
                                  managerName: init.managerName,
                                  managerID: init.managerID
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurManagerNameField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.managerName, validators_managerName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  showHistory: init.showHistory,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  budget: init.budget,
                                  managerName: status,
                                  managerID: init.managerID
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurManagerIDField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.managerID, validators_managerID, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  showHistory: init.showHistory,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  budget: init.budget,
                                  managerName: init.managerName,
                                  managerID: status
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */6 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */6,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */7,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */9);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */8);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */7 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */8 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */9 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateShowHistoryField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.showHistory, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            showHistory: status,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            budget: init.budget,
                                            managerName: init.managerName,
                                            managerID: init.managerID
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEndDateField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.endDate, state.submissionStatus, validators_endDate, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            showHistory: init.showHistory,
                                            endDate: status,
                                            startDate: init.startDate,
                                            budget: init.budget,
                                            managerName: init.managerName,
                                            managerID: init.managerID
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartDateField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.startDate, state.submissionStatus, validators_startDate, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            showHistory: init.showHistory,
                                            endDate: init.endDate,
                                            startDate: status,
                                            budget: init.budget,
                                            managerName: init.managerName,
                                            managerID: init.managerID
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateBudgetField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.budget, state.submissionStatus, validators_budget, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            showHistory: init.showHistory,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            budget: status,
                                            managerName: init.managerName,
                                            managerID: init.managerID
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateManagerNameField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.managerName, state.submissionStatus, validators_managerName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            showHistory: init.showHistory,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            budget: init.budget,
                                            managerName: status,
                                            managerID: init.managerID
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateManagerIDField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, state.fieldsStatuses.managerID, state.submissionStatus, validators_managerID, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            showHistory: init.showHistory,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            budget: init.budget,
                                            managerName: init.managerName,
                                            managerID: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */6 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */7 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */8 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateShowHistory: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateShowHistoryField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateEndDate: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateEndDateField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateStartDate: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateStartDateField */2,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateBudget: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateBudgetField */3,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateManagerName: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateManagerNameField */4,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateManagerID: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateManagerIDField */5,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurShowHistory: (function (param) {
              Curry._1(dispatch, /* BlurShowHistoryField */0);
            }),
          blurEndDate: (function (param) {
              Curry._1(dispatch, /* BlurEndDateField */1);
            }),
          blurStartDate: (function (param) {
              Curry._1(dispatch, /* BlurStartDateField */2);
            }),
          blurBudget: (function (param) {
              Curry._1(dispatch, /* BlurBudgetField */3);
            }),
          blurManagerName: (function (param) {
              Curry._1(dispatch, /* BlurManagerNameField */4);
            }),
          blurManagerID: (function (param) {
              Curry._1(dispatch, /* BlurManagerIDField */5);
            }),
          showHistoryResult: Formality.exposeFieldResult(state.fieldsStatuses.showHistory),
          endDateResult: Formality.exposeFieldResult(state.fieldsStatuses.endDate),
          startDateResult: Formality.exposeFieldResult(state.fieldsStatuses.startDate),
          budgetResult: Formality.exposeFieldResult(state.fieldsStatuses.budget),
          managerNameResult: Formality.exposeFieldResult(state.fieldsStatuses.managerName),
          managerIDResult: Formality.exposeFieldResult(state.fieldsStatuses.managerID),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.showHistory || match.endDate || match.startDate || match.budget || match.managerName || match.managerID) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */6);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */7);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */8);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */8,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */9);
            })
        };
}

var TableFilterForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var initialState$1 = {
  managerID: "",
  managerName: "",
  budget: "",
  startDate: undefined,
  endDate: undefined,
  showHistory: false
};

export {
  TableFilterForm ,
  initialState$1 as initialState,
}
/* react Not a pure module */
